import {VendorList} from "./VendorList";
import {VendorEdit} from "./VendorEdit";
import {VendorCreate} from "./VendorCreate";

export default {
    list: VendorList,
    create: VendorCreate,
    edit: VendorEdit
};
